
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    TEXT_CHANGE: 'text-change',
    TEXT_SET_ERRORS: 'text-set-errors',
    TEXT_SET_SUCCESS: 'text-set-success',
    TEXT_REMOVE_ERRORS: 'text-remove-errors',
    TEXT_AREA_CHANGE: 'text-area-change',
    TEXT_AREA_SET_ALL_DATA: 'text-area-set-all'
};

const textInputDataReducer = (state, action) => {
    //console.log("text input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.TEXT_CHANGE: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
            
            
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.TEXT_AREA_CHANGE: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
           
            var content = action.value;
            var count = 0;
            var maxLength = action.maxLength;

                //console.log(content);
                //console.log(content.substring(maxLength));
                var text = content.substring(0,maxLength);
                //console.log(content.length);
                //console.log(text.length);
                //setFeedbackMessage(text);
                //setFeedbackCharCount(text.length);
                
                return {
                    ...state,
                    value: text,
                    count: text.length,
                    validation:{
                        ...state.validation,
                        isInvalid: false,
                        errors: [],
                        isValid: false,
                        successMsgs: []
                    }
                };
        }
        case ACTIONS.TEXT_SET_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors,
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.TEXT_SET_SUCCESS: {
            //console.log("setsuccess");
            //console.log(state);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: true,
                    successMsgs: action.successMsgs
                }
            };
        }
        case ACTIONS.TEXT_REMOVE_ERRORS: {
            const path = state.data[action.name];
            return {
                ...state,
                validation:{
                    ...path.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.TEXT_AREA_SET_ALL_DATA: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
           
            var content = action.data;
           
            return content;
        }
    }
}



export {ACTIONS, textInputDataReducer};